import {
  Component, OnInit, inject, signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TosService } from '../../core/services/tos.service';
import { ToastService } from '../../core/services/toast.service';

const TOS_KEY = 'nexus_tos_accepted_v1';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tos-acceptance',
  standalone: true,
  templateUrl: './tos-acceptance.component.html',
})
export class TosAcceptanceComponent implements OnInit {
  private readonly tosSvc   = inject(TosService);
  private readonly toastSvc = inject(ToastService);

  readonly visible         = signal(false);
  readonly checkboxChecked = signal(false);

  ngOnInit(): void {
    // Backfill: if user already accepted via localStorage, persist to backend and skip modal
    if (localStorage.getItem(TOS_KEY)) {
      this.tosSvc.accept().subscribe();
      localStorage.removeItem(TOS_KEY);
      return;
    }
    this.tosSvc.check().subscribe({
      next: res => { if (!res.accepted) this.visible.set(true); },
      error: () => this.visible.set(true), // fail-open: show modal on API error
    });
  }

  accept(): void {
    this.tosSvc.accept().subscribe({
      error: () => this.toastSvc.error('Could not record acceptance. Please try again.'),
    });
    this.visible.set(false);
  }
}
